import { ProfileDto } from '@diritto/common/account/dtos/profile.dto';
import { ContentDto } from '@diritto/common/content/dtos/content.dto';
import { EventType } from '@diritto/common/event/constants';
import { EventExtraInfo } from '@diritto/common/event/types/event-extra-info-types';
import { AppInstallEventHeader } from 'app-components/events/detail/headers/AppInstallEventHeader';
import { NewContentPromoteEventHeader } from 'app-components/events/detail/headers/NewContentPromoteEventHeader';

interface EventInfoContentProps {
  type: EventType;
  info: EventExtraInfo[keyof EventExtraInfo];
  contents: Record<number, ContentDto>;
  profiles: Record<number, ProfileDto>;
}

export const EventInfoContent = ({ type, info, contents, profiles }: EventInfoContentProps) => {
  if (type === EventType.AppInstallEvent) {
    return <AppInstallEventHeader />;
  }

  if (type === EventType.NewContentPromoteEvent) {
    return (
      <NewContentPromoteEventHeader
        info={info as EventExtraInfo[EventType.NewContentPromoteEvent]}
        contents={contents}
        profiles={profiles}
      />
    );
  }

  return null;
};
